import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import VehicleTypeService from "../../../services/VehicleTypeService";
import Breadcrumb from "../../../components/Breadcrumb";
import ListVehicleType from "../Components/ListVehicleType";
import MessageDialog from "../../../components/MessageDialog";

export default function ViewVehicleType() {
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [selected, setSelected] = useState(null); //  RADIO (single select)
  const [searchText, setSearchText] = useState(""); //  SEARCH
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");
  const [loading, setLoading] = useState(true);
  // const messageTimer = useRef(null);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const navigate = useNavigate();

  const fetchVehicleTypes = async () => {
    setLoading(true);
    try {
      const res = await VehicleTypeService.getAll(currentPage, itemsPerPage);
      setVehicleTypes(res.data || []);
      setPageCount(res.totalPages || 0);
    } catch (err) {
      console.error(err);
      showMessage("Error loading vehicle types", "error");
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {
    fetchVehicleTypes();
  }, [currentPage]);


  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
    // if (messageTimer.current) clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };

  // const closeMessage = () => {
  //   setMessage("");
  //   if (messageTimer.current) clearTimeout(messageTimer.current);
  // };

  //  RADIO SELECT
  const handleSelect = (id) => {
    setSelected(id);
  };

  const handlePageClick = (event) => {
    const selectedPage = event.selected + 1;
    setCurrentPage(selectedPage);
  };


  const handleAdd = () => {
    navigate("/cpnl/vehicletype/add");
  };

  const handleModify = () => {
    if (!selected) {
      showMessage("Please select one vehicle type to modify.");
      return;
    }
    navigate(`/cpnl/vehicletype/add/${selected}`);
  };

  // 🔹 TOGGLE STATUS
  const handleToggleStatus = async (vType) => {
    const newStatus = vType.status === "Active" ? "Inactive" : "Active";

    if (!window.confirm(`Are you sure do you want to change as ${newStatus}?`))
      return;

    setLoading(true);
    try {
      const res = await VehicleTypeService.toggleStatus(vType.id);
      showMessage(`Vehicle type changed as ${res.newStatus}.`, "success");
      fetchVehicleTypes();
    } catch (err) {
      console.error(err);
      showMessage("Error updating status", "error");
    } finally {
      setLoading(false);
    }
  };

  const getStatusText = (status) =>
    status === "Active" ? "Active" : "Inactive";

  const getStatusClass = (status) =>
    status === "Active" ? "bg-success" : "bg-secondary";

  //  SEARCH FILTER
  const filteredVehicleTypes = vehicleTypes.filter((v) =>
    v.vehicleType.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <>
      <Breadcrumb pageTitle="Vehicle Types" secondTitle="Masters" />

      <div className="row">
        <div className="card py-2 bg-white shadow-sm">

          {/* {message && (
            <div
              className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
                } d-flex justify-content-between align-items-center w-100 mb-2 p-2`}
            >
              <span>{message}</span>
              <button
                type="button"
                className="btn-close"
                onClick={closeMessage}
              ></button>
            </div>
          )} */}

            <MessageDialog
              message={message}
              type={msgType}
              setMessage={setMessage}
              setMsgType={setMsgType}
            />
          

          {/*  SEARCH + BUTTONS */}
          <div className="mb-3 pb-2 border-bottom d-flex align-items-end gap-3">
            <div>
              <input
                type="text"
                className="form-control"
                placeholder="Search Vehicle Type"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
            <div className="ms-auto d-flex gap-2">
              <button
                className="d-inline-flex btn btn-success"
                onClick={handleAdd}
                disabled={loading}
              >
                <i className="ti ti-plus me-1"></i> Add
              </button>

              <button
                className="d-inline-flex btn btn-warning"
                onClick={handleModify}
                disabled={loading}
              >
                <i className="ti ti-pencil me-1"></i> Modify
              </button>
            </div>
          </div>

          {/*  TABLE */}
          <ListVehicleType
            loading={loading}
            filteredVehicleTypes={filteredVehicleTypes}
            selected={selected}
            handleSelect={handleSelect}
            handleToggleStatus={handleToggleStatus}
            getStatusClass={getStatusClass}
            getStatusText={getStatusText}
            pageCount={pageCount}
            handlePageClick={handlePageClick}
          />

        </div>
      </div>
    </>
  );
}
